import PropTypes from 'prop-types';
import React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classNames from 'classnames';
import { getComponentClasses } from '@99designs/utils/app';
import FixedViewportElement from './FixedViewportElement';

export default class FullscreenOverlay extends React.Component {
    render() {
        const data = { 'data-fullscreen-overlay-active': true };
        const classes = classNames(
            getComponentClasses('fullscreen-overlay', this.props.variations),
            {
                'fullscreen-overlay--scrollable-small-screen': this.props.isScrollableSmallScreens,
            }
        );

        if (this.props.enableScroll && this.props.isActive) {
            data['data-enable-scroll'] = true;
        }

        if (this.props.hasAdminBarOffset) {
            data['data-offset-admin-bar'] = true;
        }

        return (
            <FixedViewportElement isEnabled={this.props.isActive && !this.props.isClosing}>
                <div className={classes} {...data}>
                    <CSSTransitionGroup
                        transitionName="fullscreen-overlay-"
                        transitionAppear={this.props.hasOpeningAndClosingAnimation}
                        transitionLeave={this.props.hasOpeningAndClosingAnimation}
                        transitionEnterTimeout={this.props.animationDuration}
                        transitionAppearTimeout={this.props.animationDuration}
                        transitionLeaveTimeout={this.props.animationDuration}
                    >
                        {!this.props.isClosing && (
                            <div
                                onClick={this.props.onClick}
                                className="fullscreen-overlay__content"
                            >
                                {this.props.children}
                            </div>
                        )}
                    </CSSTransitionGroup>
                </div>
            </FixedViewportElement>
        );
    }
}

FullscreenOverlay.propTypes = {
    isActive: PropTypes.bool.isRequired,
    isScrollableSmallScreens: PropTypes.bool,
    hasOpeningAndClosingAnimation: PropTypes.bool,
    animationDuration: PropTypes.number,
    isCLosing: PropTypes.bool,
    hasAdminBarOffset: PropTypes.bool,
    enableScroll: PropTypes.bool,
    variations: PropTypes.array,
};

FullscreenOverlay.defaultProps = {
    isActive: false,
    isScrollableSmallScreens: false,
    hasOpeningAndClosingAnimation: false,
    animationDuration: 230,
    isClosing: false,
    hasAdminBarOffset: false,
    enableScroll: false,
    variations: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/FullscreenOverlay.jsx